import React, {ComponentType, createContext, FC} from 'react';
import {Diff} from 'utility-types';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

export enum BannerPrioritiesEnum {
  INFORMATION = 'INFORMATION',
  ERROR = 'ERROR',
  TRANSIENT = 'TRANSIENT',
}

export interface BannerDefinition {
  id: number;
  priority: BannerPrioritiesEnum;
  node: HTMLElement;
}

export type BannerCreator = (definition: BannerDefinition) => Handler;

export interface BannersApiContextProps {
  createBanner?: BannerCreator;
}

// Note: the List and Api contexts are separated so that updates to the banner list do not
// re-render Consumers merely interested in the Api (e.g, the Banner component).
export const BannersListContext = createContext<ReadonlyArray<BannerDefinition>>([]);
export const BannersApiContext = createContext<BannersApiContextProps>({});

/*
 * HOC.
 */

export function withBannersApi<T extends object>(
  Component: ComponentType<T & BannersApiContextProps>,
): FC<Diff<T, BannersApiContextProps>> {
  return function WithBannersApi(props) {
    return (
      <BannersApiContext.Consumer>
        {(context) => <Component {...(props as any)} {...context} />}
      </BannersApiContext.Consumer>
    );
  };
}
